/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Manual_Qc_Delete_ConfirmInputs */

const en_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"?`)
};

const fr_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer "${i?.name}" ?`)
};

const de_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich löschen?`)
};

const it_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare "${i?.name}"?`)
};

const ru_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.name}"?`)
};

const es_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas eliminar "${i?.name}"?`)
};

const zh_cn2_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除“${i?.name}”吗？`)
};

const ja_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を削除してもよろしいですか?`)
};

const hi_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.name}" को हटाना चाहते हैं?`)
};

const pt_pt2_manual_qc_delete_confirm = /** @type {(inputs: Manual_Qc_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.name}"?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"?" |
*
* @param {Manual_Qc_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_delete_confirm = /** @type {((inputs: Manual_Qc_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_delete_confirm(inputs)
	if (locale === "de") return de_manual_qc_delete_confirm(inputs)
	if (locale === "it") return it_manual_qc_delete_confirm(inputs)
	if (locale === "ru") return ru_manual_qc_delete_confirm(inputs)
	if (locale === "es") return es_manual_qc_delete_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_delete_confirm(inputs)
	if (locale === "ja") return ja_manual_qc_delete_confirm(inputs)
	if (locale === "hi") return hi_manual_qc_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_delete_confirm(inputs)
	return en_manual_qc_delete_confirm(inputs)
});